export default __webpack_public_path__ + "static/media/check-icon.d206274d.svg";